import AppInstance from "../config/appInstance"
import axios from "axios";

export default class ApiUtil {
	static async SendAsync(request) {
		try {
			console.log('=== API UTIL DEBUG ===');
			console.log('Request object:', request);
			console.log('Full request URL will be constructed by AppInstance');
			
			const res = await AppInstance(request);
			
			console.log('=== API UTIL RESPONSE ===');
			console.log('Response status:', res.status);
			console.log('Response data:', res.data);
			console.log('Response headers:', res.headers);
			
			return res;
		} catch (error) {
			console.error('=== API UTIL ERROR ===');
			console.error('Error details:', error);
			console.error('Error response:', error.response);
			console.error('Error request:', error.request);
			
			if (axios.isCancel(error)) {
				// Request was canceled
				console.log('Request was canceled');
			} else {
				// Handle other errors
				console.error('Non-cancel error occurred');
			}
			throw error;
		}
	}
}
